import { Element } from "@xmpp/xml"
import * as Sentry from "@sentry/react"

const iqMeasure = (
  iqCaller: any,
  presetName?: string,
): {
  request: (xml: Element, timeout?: number | undefined) => Promise<Element>
} => {
  return {
    request: (xml: Element, timeout?: number | undefined) => {
      const name = presetName || guessIqName(xml)
      return Sentry.startSpan(
        {
          name: name || "unknown",
          op: "xmpp.iq",
          attributes: { "xmpp.iq.name": name || "unknown" },
        },
        async () => {
          return await iqCaller.request(xml, timeout)
        },
      )
    },
  }
}

const guessIqName = (xml: Element): string | null => {
  const toplevel = xml.getChildElements()[0]
  if (!toplevel) {
    return "unknown"
  }

  if (toplevel.name === "command") {
    return `command.${toplevel.attrs.node}`
  }

  if (toplevel.name === "pubsub") {
    const child = toplevel.getChildElements()[0]
    if (!child) {
      return "pubsub"
    }

    return `pubsub.${child.name}.${child.attrs.node}`
  }

  return "unknown"
}

export default iqMeasure
export { guessIqName }
